import styles from "../../ui/tabs/style.module.css";

const TabButton = ({ tabName , apiType, setApiType}) => (
  <button
    className={`${styles.button} ${
      apiType === tabName ? styles.buttonActive : ""
    }`}
    onClick={() => setApiType(tabName)}
  >
    {tabName}
  </button>
);

const Tabs = ({tabList, apiType, setApiType}) => {
  return (
    <div className={styles.tabs}>
      {tabList.map((tabs) => (
        <TabButton tabName={tabs.name} apiType={apiType} setApiType={setApiType}/>
      ))}
    </div>
  );
};

export default Tabs;
